import * as React from 'react';
import { observer } from 'mobx-react';
import { ErrorBoundary } from '../../Shared/components/error-boundary';
import { BrandingTheme } from '../../WebGiving/branding/branding-theme';
import { classNames } from '../../Shared/utils/classnames';
import { IPayerOnboardingMainViewModel } from './payer-onboarding-main-view-model';
import { PayerOnboardingInfoBanner } from './banner/payer-onboarding-info-banner';
import { Panel, PanelType } from '../../WebGiving/components/panel';
import { Router } from '../pages/router';
import { MainHeader } from '../../WebGiving/components/header/header';
import { PayerOnboardingMainFooter } from './payer-onboarding-main-footer';
import { NotificationController } from '../../WebGiving/components/notification/notification';
import { ModalCommodore } from '../modals/modal-commodore';
import { PayerOnboardingPage } from '../pages';

import {
	main,
	container,
	loading,
	header,
} from '../../WebGiving/main/webgiving-main.less';

@observer
export class PayerOnboardingMain extends React.Component<{ vm: IPayerOnboardingMainViewModel}> {
	render() {
		const {
			theme,
			currentPageViewModel,
			isAppLoading,
			reportError,
			raiseAction,
			notification,
			setCurrentPageShouldBeVisible,
			viewData: {
				MerchantInfo: merchant,
				PushpayInfo: pushpayInfo,
				BrandingPackage: brandingPackage,
			},
		} = this.props.vm;
		const pageIsEnterDetails = currentPageViewModel.type === PayerOnboardingPage.EnterDetails;
		return (
			<div>
				<BrandingTheme theme={theme} />
				<ErrorBoundary onError={reportError}>
					<MainHeader logoUrl={merchant.LogoUrl}
						merchantWebsiteUrl={merchant.WebsiteUrl}
						tradingName={merchant.TradingName}
						welcomeMessage=""
						onError={reportError}
						brandingPackage={brandingPackage}
						className={classNames(header, 'brand-secondary-bg')} />
				</ErrorBoundary>
				<main className={classNames(main, { [`${loading} brand-primary-before-color`]: isAppLoading })}>
					<ErrorBoundary onError={reportError}>
						<NotificationController viewModel={notification} />
					</ErrorBoundary>
					<div className={`container ${container}`}>
						{pageIsEnterDetails &&
							<ErrorBoundary onError={reportError}>
								<PayerOnboardingInfoBanner raiseAction={raiseAction}/>
							</ErrorBoundary>
						}
						<Panel panelType={PanelType.Highlight} responsive>
							<Router
								viewModel={currentPageViewModel}
								setCurrentPageShouldBeVisible={setCurrentPageShouldBeVisible}
								raiseAction={raiseAction}
								onError={reportError} />
						</Panel>
					</div>
					<ErrorBoundary onError={reportError}>
						<PayerOnboardingMainFooter
							merchant={merchant}
							pushpayInfo={pushpayInfo}
							raiseAction={raiseAction} />
					</ErrorBoundary>
					<ErrorBoundary onError={reportError}>
						<ModalCommodore vm={this.props.vm} onError={reportError} />
					</ErrorBoundary>
				</main>
			</div>
		);
	}
}
